import React, { useState } from "react";
import styles from "./SubCategoryModal.module.css";

export default function InactivitySettingsModal({ data, onSave, onCancel }) {
  const [period, setPeriod] = useState(data.inactivityPeriodInMonths || "");
  const [reminders, setReminders] = useState(data.reminderCountBeforeSend || "");

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <h2>Inactivity Settings</h2>

        <input
          type="number"
          placeholder="Inactivity Period (months)"
          value={period}
          onChange={(e) => setPeriod(Number(e.target.value))}
          className={styles.input}
        />

        <input
          type="number"
          placeholder="Number of reminders before sending"
          value={reminders}
          onChange={(e) => setReminders(Number(e.target.value))}
          className={styles.input}
        />

        <div className={styles.footer}>
          <button
            className={styles.saveBtn}
            onClick={() =>
              onSave({
                inactivityPeriodInMonths: period,
                reminderCountBeforeSend: reminders,
              })
            }
          >
            Save
          </button>

          <button className={styles.cancelBtn} onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
